// extracted by mini-css-extract-plugin
export default {"wrapper":"WidgetSource_wrapper__YdaGU"};